import { useState } from "react";

import Button from "@mui/material/Button";
import { useFieldArray } from "react-hook-form";
import { estimateShell, calculateShell } from "../../API`s/pv/sqliteApi";
import { toLegacy } from "../../fieldTranslation";
import { computeShellUID } from "../../../../../../utils/pvUID";
import checkRequiredFields from "../../../../../../utils/checkRequiredFields";
import CustomAlert from "../../../../../../components/widgets/CustomAlert";
import { Stack, ListItemIcon, Box, Grid, Snackbar, Alert } from "@mui/material";
import InputTable from "./InputTable";
import ResultTable from "./ResultTable";
import EstimationTable from "./EstimationTable";
import { usePVContext } from "../PVContext";
//The Main Function
const ShellTab = (props) => {
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity (success or error)
  const [openSnackbar, setOpenSnackbar] = useState(false); // Control Snackbar visibility

  const { reRender, project, equipId } = props;
  const [resultVisibility, setresultVisibility] = useState(false);
  const [estimationVisibility, setEstimationVisibility] = useState(false);
  const { control, setValue, getValues, currentRevision, revisionLoadVersion } =
    usePVContext();
  const [isLoading, setIsLoading] = useState(false);
  const [showProgressBars, setShowProgressBars] = useState(false);

  const { fields: estimationFields } = useFieldArray({
    control,
    name: "DataGridView7",
  });
  const [openAlert, setOpenAlert] = useState(false);
  const [AlertContent, setAlertContent] = useState({
    severity: "",
    message: "",
  });

  const buildShellCalcInputs = () => {
    const raw = getValues();
    const data = { ...raw };

    if (!data.txt_DP_CSC && data.designInternalPressure) {
      data.txt_DP_CSC = data.designInternalPressure;
    }

    if (!data.txt_AS_CSC && data.shellStress) {
      data.txt_AS_CSC = data.shellStress;
    }

    if (!data.txt_JE_CSC && data.jointEffLong) {
      data.txt_JE_CSC = data.jointEffLong;
    }

    if (!data.txt_ID_CSC && data.vesselDiameter) {
      data.txt_ID_CSC = data.vesselDiameter;
    }

    if (!data.txt_PT_CSC) {
      const shellRows = data.DataGridView5;
      if (shellRows && shellRows.length && shellRows[0]["Provided Thk"]) {
        data.txt_PT_CSC = shellRows[0]["Provided Thk"];
      }
    }

    if (!data.txt_CA_CSC && data.corrosionAllowanceShell) {
      data.txt_CA_CSC = data.corrosionAllowanceShell;
    }

    if (!data.txt_DL_CSC && data.vesselLengthSS) {
      data.txt_DL_CSC = data.vesselLengthSS;
    }

    return data;
  };

  //calculation results
  const showResults = async () => {
    const data = buildShellCalcInputs();
    //const data = getValues();
    console.log(data);
    setEstimationVisibility(false);

    const result = checkRequiredFields(data);
    console.log(result);
    if (result[0] === false) {
      setAlertContent({
        message: "Following values are missingaas: " + result[1],
        severity: "error",
      });
      setOpenAlert(true);
    } else {
      setresultVisibility(true);
      setIsLoading(true);
      const res = await calculateShell(toLegacy(data));
      console.log("resss", res);

      setIsLoading(false);
      if (res.error) {
        console.log(res.error);
      } else {
        setValue("DataGridView6", res.data.DataGridView6);
      }
    }
  };

  const showEstimation = async () => {
    const data = getValues();
    setIsLoading(true);
    setShowProgressBars(true);
    setresultVisibility(false);
    setEstimationVisibility(true);

    // Pre-populate any missing UIDs before sending to API
    const shellRows = data.DataGridView5 || [];
    const projectTag = data.tagNo || "";
    shellRows.forEach((row, i) => {
      if (!row.UID && row.Component) {
        const uid = computeShellUID(row.Component, projectTag);
        setValue(`DataGridView5.${i}.UID`, uid);
        row.UID = uid;
      }
    });

    const response = await estimateShell(toLegacy(data));
    setIsLoading(false);
    setShowProgressBars(false);
    if (response.error) {
      console.log(response.error);
    } else {
      setValue("DataGridView7", response.data.DataGridView7);
      // Preserve UIDs from original rows if the API response strips them
      const returnedRows = response.data.DataGridView5 || [];
      const mergedRows = returnedRows.map((row, i) => ({
        ...row,
        UID:
          shellRows[i]?.UID || computeShellUID(row.Component, projectTag) || "",
      }));
      setValue("DataGridView5", mergedRows);
    }
  };

  const onUpdate3d = async () => {
    setSnackbarMessage("Update in progress");
    setSnackbarSeverity("info");
    setOpenSnackbar(true);

    const data = getValues()?.DataGridView5;
    const orientation = getValues("orientation");

    // ── Debug: log every field of every row ──
    console.group("Shell Update 3D — pre-flight check");
    console.log("Raw DataGridView5 rows:", data);
    console.log("Orientation:", orientation);

    const requiredFields = [
      "Component",
      "Diameter",
      "Material",
      "Can Length",
      "Long Seam",
      "Provided Thk",
    ];
    let emptyFound = false;

    data?.forEach((row, idx) => {
      console.log(`Row ${idx}:`, JSON.stringify(row));
      requiredFields.forEach((field) => {
        const val = row[field];
        if (
          val === "" ||
          val === null ||
          val === undefined ||
          String(val).trim() === ""
        ) {
          console.error(
            `  ❌ EMPTY FIELD — Row ${idx}, field "${field}" = "${val}"`,
          );
          emptyFound = true;
        }
      });
    });
    console.groupEnd();

    if (emptyFound) {
      setSnackbarMessage(
        "Please fill all Shell & Head fields (check console for details).",
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    const projectTag = getValues("tagNo") || "";
    const SHELL_FIELDS = [
      "Component",
      "Diameter",
      "Material",
      "Can Length",
      "Long Seam",
      "Provided Thk",
      "Weight",
      "UID",
    ];

    const fomattedForFreeCadData = {
      data: {
        orientation: orientation,
        shellDesign: data?.map((row, i) => {
          const { id, ...rest } = row;
          const clean = {};
          SHELL_FIELDS.forEach((field) => {
            let val = rest[field];
            if (field === "UID") {
              val = val || computeShellUID(rest["Component"], projectTag) || "";
            }
            if (val === null || val === undefined) {
              val = ["Component", "Material", "UID"].includes(field) ? "" : 0;
            }
            clean[field] = val;
          });
          return { ...clean, rowNo: i };
        }),
      },
    };
    console.log(
      "Payload sent to InvElectron:",
      JSON.stringify(fomattedForFreeCadData, null, 2),
    );

    let updateResponse = null;
    let updateError = null;

    try {
      updateResponse = await window.electron.pv.updateShell3d(
        fomattedForFreeCadData,
      );
      console.log("response :", updateResponse);
    } catch (error) {
      updateError = error;
      console.error("Shell 3D update failed:", error);
    }

    if (!updateError) {
      setSnackbarMessage(updateResponse?.message || "Shell 3D updated.");
      setSnackbarSeverity(updateResponse?.ok === false ? "error" : "success");
    } else {
      setSnackbarMessage("Shell 3D update failed.");
      setSnackbarSeverity("error");
    }
    setOpenSnackbar(true);
  };

  const hasSecondaryTable = resultVisibility || estimationVisibility;

  return (
    <div
      style={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        boxSizing: "border-box",

        overflowX: "hidden",

        backgroundColor: "transparent",
      }}
    >
      <CustomAlert
        open={openAlert}
        setOpen={setOpenAlert}
        severity={AlertContent.severity}
        message={AlertContent.message}
      />

      <br />

      <Stack
        spacing={2}
        direction="row"
        sx={{
          flexWrap: "wrap",
        }}
      >
        <Button
          color={resultVisibility ? "secondary" : "primary"}
          onClick={() => showResults()}
          variant="contained"
        >
          Calculate
        </Button>

        <Button
          color={estimationVisibility ? "secondary" : "primary"}
          onClick={() => showEstimation()}
          variant="contained"
        >
          Estimate
        </Button>
      </Stack>

      <br />

      <Box
        sx={{
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",

          overflowX: "hidden",
        }}
      >
        <Grid
          container
          spacing={1}
          columns={12}
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",

            m: 0,

            overflowX: "hidden",
          }}
        >
          {/* Shell Input Table */}
          <Grid
            item
            xs={12}
            md={hasSecondaryTable ? 6.5 : 12}
            sx={{
              minWidth: 0,
              maxWidth: "100%",

              overflow: "hidden",
            }}
          >
            <InputTable
              key={`shell-input-${currentRevision}-${revisionLoadVersion}`}
              reRender={reRender}
              isLoading={isLoading}
              projectId={project.id}
            />
          </Grid>

          {/* Calculate Result */}
          {resultVisibility && (
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{
                minWidth: 0,
                maxWidth: "100%",

                overflow: "hidden",
              }}
            >
              <ResultTable isLoading={isLoading} />
            </Grid>
          )}

          {/* Estimation */}
          {estimationVisibility && (
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{
                minWidth: 0,
                maxWidth: "100%",

                overflow: "hidden",
              }}
            >
              <EstimationTable
                key={`shell-estimation-${currentRevision}-${revisionLoadVersion}`}
                isLoading={isLoading}
                projectId={project.id}
                equipId={equipId}
              />
            </Grid>
          )}
        </Grid>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default ShellTab;
